<div
  class="form-control__wrapper form-array__wrapper"
  data-test-id="formArrayWrapper"
  [ngClass]="{
    'form-control__wrapper--inline': direction === 'row',
    'form-control__wrapper--flat': direction === 'filter',
  }"
>
  <label class="form-control__label" data-test-id="formArrayLabelWrapper">
    <p class="t-data t-bold" data-test-id="formArrayLabel">
      {{ formArrayConfig.label }}
    </p>
  </label>

  <div class="form-array__controls u-fillRemaining">
    @for (
      controlConfig of formArrayConfigs;
      track controlConfig;
      let i = $index
    ) {
      <div
        class="form-array-control u-flex"
        [attr.data-test-id]="'formArrayControlWrapper_' + i"
        [ngClass]="{
          'u-alignBaseline': formArrayConfigs.length > 1,
        }"
      >
        <form-control
          direction="array"
          [group]="group.controls[formArrayConfig.prop]"
          [config]="controlConfig"
          [control]="group.controls[formArrayConfig.prop].controls[i]"
          [attr.data-test-id]="'formArrayControl_' + i"
        >
        </form-control>
        @if (formArrayConfigs.length === 1) {
          <zip-button
            (zipButtonClicked)="addItem()"
            level="medium"
            icon="add"
            content="Additional"
            [attr.data-test-id]="'formArrayAddButton_' + i"
          >
          </zip-button>
        } @else {
          <div
            class="icon-container"
            [attr.data-test-id]="'formArrayIconsContainer_' + i"
          >
            <i
              class="icon icon--small icon--pointer icon--success"
              [attr.data-test-id]="'formArrayAddIcon_' + i"
              (click)="addItem(i)"
              >add</i
            >
            <i
              class="icon icon--small icon--pointer icon--error"
              [attr.data-test-id]="'formArrayBulletIcon_' + i"
              (click)="removeItem(i)"
              >bullet</i
            >
          </div>
        }
      </div>
    }
  </div>
</div>
